import type { League } from '@h2h/shared';
import { Lock } from '../../components/ui/icons';
import { NationalFlagEmblem } from '../../components/ui/NationalFlagEmblems';
import { useLeagueMemberCount } from '../../hooks/useQueries';
import { leagueWaitingNote, type LeagueIdentity } from '../../data/leagues';
import { compactCount } from '../../lib/format';

export function WaitingRow({
  identity,
  league,
  unread
}: {
  identity: LeagueIdentity;
  league?: League;
  unread: number;
}) {
  const { data: count } = useLeagueMemberCount(identity.leagueId);
  return (
    <div className="flex items-center gap-[13px] rounded-[18px] border border-black/7 bg-fill/60 p-[12px_14px]">
      <div className="relative shrink-0">
        <NationalFlagEmblem leagueId={identity.leagueId} country={identity.country} size="sm" muted />
        {unread > 0 && (
          <span className="absolute -right-[3px] -top-[3px] h-[10px] w-[10px] rounded-full border-2 border-white bg-accent" />
        )}
      </div>
      <div className="flex-1">
        <div className="text-[14px] font-bold tracking-[-0.01em] text-ink2">{league?.name ?? identity.name}</div>
        <div className="text-[12px] font-medium text-ink3">
          {identity.country} · {leagueWaitingNote(identity.leagueId)}
          {count != null ? ` · ${compactCount(count)}` : ''}
        </div>
      </div>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-fill px-[10px] py-[6px] text-[11px] font-bold text-ink3">
        <Lock width={12} height={12} strokeWidth={2.4} />
        Waiting
      </span>
    </div>
  );
}
